<div class="container-fluid px-4 py-3">

  <div class="row mb-4">
    <div class="col-12">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/notificaciones/crear']">Crear notificación</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" href="#">Enviados</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <!-- Loading spinner -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-3">Cargando notificaciones...</p>
      </div>

      <!-- Tabla de notificaciones -->
      <div *ngIf="!loading" class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Título</th>
              <th>Mensaje</th>
              <th>Tipo</th>
              <th>Importancia</th>
              <th>Destinatarios</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let notification of notifications">
              <td>
                <strong>{{ notification.title }}</strong>
              </td>
              <td>
                <span class="text-truncate d-inline-block" style="max-width: 300px;" [title]="notification.message">
                  {{ notification.message }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="getTypeClass(notification.notification_type)">
                  {{ notification.notification_type }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="getImportanceClass(notification.importance)">
                  {{ notification.importance }}
                </span>
              </td>
              <td>
                <i class="bi bi-people-fill me-1"></i>
                {{ getRecipientText(notification) }}
              </td>
              <td>
                <small>{{ formatDate(notification.created_at) }}</small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación unificada estilo Usuarios -->
      <div *ngIf="!loading && notifications.length > 0" class="pagination-container mt-3" aria-label="Paginación de notificaciones">
        <div class="d-flex flex-wrap justify-content-between align-items-center w-100 gap-3">
          <div class="d-flex align-items-center gap-2">
            <label for="pageSizeSelect" class="form-label mb-0 small">Mostrar:</label>
            <select id="pageSizeSelect" class="form-select form-select-sm" [(ngModel)]="pageSize" (change)="onPageSizeChange()" aria-label="Seleccionar cantidad por página">
              <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <nav class="ms-auto" aria-label="Navegación de páginas">
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <button class="page-link" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" aria-label="Página anterior">&laquo;</button>
              </li>
              <li class="page-item" *ngFor="let p of getPageNumbers()" [class.active]="p === currentPage">
                <button class="page-link" (click)="goToPage(p)" [attr.aria-current]="p === currentPage ? 'page' : null">{{ p }}</button>
              </li>
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <button class="page-link" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" aria-label="Página siguiente">&raquo;</button>
              </li>
            </ul>
          </nav>
          <span class="small text-muted ms-2">Página {{ currentPage }} de {{ totalPages }} ({{ startItem }} - {{ endItem }} de {{ totalItems }})</span>
        </div>
      </div>

      <!-- Mensaje cuando no hay notificaciones -->
      <div *ngIf="!loading && notifications.length === 0" class="text-center py-5">
        <i class="bi bi-bell-slash" style="font-size: 3rem; color: #6c757d;"></i>
        <p class="mt-3 text-muted">No hay notificaciones enviadas aún</p>
        <button class="btn btn-primary mt-2" (click)="createNotification()">
          <i class="bi bi-plus-circle me-2"></i>
          Crear primera notificación
        </button>
      </div>
    </div>
  </div>
</div>
